import { useState } from 'react';
import type { AuditFilters as Filters } from '../../api/audit';

export function AuditFilters({ initial, onSearch }: { initial: Filters; onSearch: (f: Filters) => void }) {
  const [from, setFrom] = useState(initial.from ?? '');
  const [to,   setTo]   = useState(initial.to   ?? '');
  const [entity, setEntity] = useState(initial.entity ?? '');
  const [operatorId, setOperatorId] = useState(initial.operatorId ?? '');

  return (
    <div className="card" style={{ display: 'grid', gap: 'var(--sp-2)', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
      <label>From <input type="datetime-local" value={from} onChange={(e) => setFrom(e.target.value)} /></label>
      <label>To   <input type="datetime-local" value={to}   onChange={(e) => setTo(e.target.value)} /></label>
      <label>Entity     <input type="text" placeholder="floor:top" value={entity} onChange={(e) => setEntity(e.target.value)} /></label>
      <label>Operator   <input type="text" placeholder="user_..." value={operatorId} onChange={(e) => setOperatorId(e.target.value)} /></label>
      <button onClick={() => {
        const next: Filters = { limit: 200 };
        if (from) next.from = new Date(from).toISOString();
        if (to)   next.to   = new Date(to).toISOString();
        if (entity) next.entity = entity;
        if (operatorId) next.operatorId = operatorId;
        onSearch(next);
      }}>Search</button>
    </div>
  );
}
